import { useQuery } from '@tanstack/react-query';

import { queryClient } from '@/lib/queryClient';

import { getPublicIdInformationDetail } from './api';
import { publicIdInformationDetailKey } from './key';
export type { GetPublicIdInformationDetailResponse } from './type';

export function prefetchPublicIdInformationDetail(personId: string) {
  return queryClient.ensureQueryData({
    queryKey: publicIdInformationDetailKey.detail(personId),
    queryFn: () => getPublicIdInformationDetail(personId),
    staleTime: 5 * 60 * 1000,
  });
}

export function useGetPublicIdInformationDetail(personId: string) {
  return useQuery({
    queryKey: publicIdInformationDetailKey.detail(personId),
    queryFn: () => getPublicIdInformationDetail(personId),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
